import { required } from "@vuelidate/validators";
import type { ValidationArgs } from "@vuelidate/core";

export interface AppTypeForm {
  helpText: string;
}

export function getAppTypeFormRules(
  _unusedForm: AppTypeForm,
): ValidationArgs<AppTypeForm> {
  return {
    helpText: {
      required,
    },
  };
}

export const validationMessages: Record<keyof AppTypeForm, object> = {
  helpText: {
    required: "The help text is required",
  },
};

export const fieldLabelsMap: Record<keyof AppTypeForm, string> = {
  helpText: "Help Text",
};
